
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { useLocation } from 'react-router-dom';

function AppContent() {
  const location = useLocation();
  const hidePromoStrip = location.pathname === '/thank-you';

  return (
    <>
      <AppRoutes />
      
      {/* Bottom Promotional Strip - Mobile Optimized - Hidden on Thank You page */}
      {!hidePromoStrip && (
        <div className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-r from-cyan-400 via-emerald-400 to-cyan-400 shadow-[0_-5px_25px_rgba(16,185,129,0.4)]">
          <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 py-2.5 sm:py-2">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-3">
              {/* Left Side - Pricing Info with Deadline */}
              <div className="flex flex-col items-center sm:items-start w-full sm:w-auto">
                <div className="flex items-center gap-2 sm:gap-3">
                  <span className="text-gray-900 font-bold text-base sm:text-base">₹99</span>
                  <span className="text-gray-700 text-sm sm:text-sm line-through">₹4,999</span>
                  <span className="text-gray-900 font-semibold text-sm sm:text-sm">98% OFF</span>
                </div>
                <span className="text-gray-900 font-medium text-xs mt-0.5">Deadline 30th January 2026</span>
              </div>
              
              {/* Right Side - CTA Button with Seats Left */}
              <div className="flex flex-col items-center sm:items-end gap-0.5 w-full sm:w-auto">
                <span className="text-gray-900 font-semibold text-xs">30 Seats Left</span>
                <button 
                  onClick={() => window.REACT_APP_NAVIGATE('/checkout')}
                  className="relative bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-8 sm:px-8 py-2.5 sm:py-2.5 rounded-full text-sm sm:text-sm font-bold whitespace-nowrap cursor-pointer transition-all duration-300 shadow-[0_0_20px_rgba(59,130,246,0.6)] hover:shadow-[0_0_30px_rgba(59,130,246,0.9)] animate-pulse-glow w-full sm:w-auto"
                >
                  <span className="relative z-10">Enroll Now</span>
                  <div className="absolute inset-0 bg-white/20 rounded-full animate-ping"></div>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
